// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__3K0Nq","avatar":"style_avatar__1Lhu-","menuIcon":"style_menuIcon__3Nc6y"};